import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "./Entities/Home";
import { DrJuanAbc } from "./Entities/pages/DrJuanAbc";
import { PodologoMondragon } from "./Entities/pages/PodologoMondragon";
import { CynthiaMichelle } from "./Entities/pages/CynthiaMichelle";
import { FisioTerapia } from "./Entities/pages/Fisioterapia";
import { DrLuisCabrera } from "./Entities/pages/DrLuisCabrera";
import { DrAntonioTester } from "./Entities/pages/DrAntonioTester";
import { DraLineyNolasco } from "./Entities/pages/DraLineyNolasco";
import { CitaConfirmada } from "./Entities/CitaConfirmada";
import { Consulta } from "./Entities/Consulta/Consulta";
import { Physiovital } from "./Entities/pages/Physiovital";
import { App as AppProd } from "./Entities/App";
import { Dashboard } from "./Entities/Dashboard";
import { AgendaCitas } from "./Entities/Citas/AgendaCitas";
import { Pacientes } from "./Entities/Pacientes/Pacientes";
import { Expediente } from "./Entities/Pacientes/Expediente";
import { Laboratorios as ConsultaLabs } from "./Entities/Consulta/Laboratorios";
import { FinConsulta } from "./Entities/Consulta/FinConsulta";
import { AgendaSemana } from "./Entities/Citas/AgendaSemana";
import { Servicios } from "./Entities/Configuraciones/Servicios";
import { Horarios } from "./Entities/Configuraciones/Horarios";
import { AvisoPrivacidad } from "./Entities/Terminos/AvisoPrivacidad";
import { TerminosServicio } from "./Entities/Terminos/TerminosServicio";
import "rsuite/dist/rsuite.min.css";
import "@coreui/coreui/dist/css/coreui.min.css";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" Component={Home} />
        <Route path="/Home/Dashboard" Component={Dashboard} />
        <Route
          path="/Laboratorios/:idPaciente/:paciente"
          Component={ConsultaLabs}
        />
        <Route
          path="/Home/Dashboard/Consulta/FinConsulta/:pacienteAtendido/:nombreDoctor/:specialty/:proxFecha/:proxHora/:idPaciente/:proxPaciente/:telefono/:espacio"
          Component={FinConsulta}
        />
        <Route path="/AvisoPrivacidad" Component={AvisoPrivacidad} />
        <Route path="/TerminosServicio" Component={TerminosServicio} />
        <Route path="/Home/Horarios" Component={Horarios} />
        <Route path="/Home/Servicios" Component={Servicios} />
        <Route path="/Home/AgendaCitas" Component={AgendaCitas} />
        <Route path="/Home/AgendaSemana" Component={AgendaSemana} />
        <Route path="/Home/Pacientes" Component={Pacientes} />
        <Route path="Home/Expediente" Component={Expediente} />
        <Route path="/Home/Dashboard/Consulta/:espacio" Component={Consulta} />
        <Route path="/DrJuanAbc" Component={DrJuanAbc} />
        <Route path="/PodologoMondragon" Component={PodologoMondragon} />
        <Route path="/CynthiaMichelle" Component={CynthiaMichelle} />
        <Route path="/Fisioterapia" Component={FisioTerapia} />
        <Route path="/DrLuisCabrera" Component={DrLuisCabrera} />
        <Route path="/DrAntonioTester" Component={DrAntonioTester} />
        <Route path="/DraLineyNolasco" Component={DraLineyNolasco} />
        <Route path="/Physiovital" Component={Physiovital} />
        <Route path="/CitaConfirmada/:id/:phone" Component={CitaConfirmada} />
      </Routes>
    </Router>
  );
}

export default App;
